import { RouteProp, useFocusEffect, useNavigation, useRoute } from "@react-navigation/native";
import { useCallback } from "react";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { useAuth } from "../hooks/useAuth";
import BlankLayout from "../layouts/BlankLayout";
import Loader from "../components/common/status/Loader/Loader";
import type { RootStackParamList } from "../navigation/navigation.types";
import returnToUtils from "../utils/returnTo.utils";
import { useAppConfig } from "../AppConfigProvider";
import { getDefaultAuthenticatedRoute } from "../utils/authRoutes.utils";

function LoginLTIView() {
  const route = useRoute<RouteProp<RootStackParamList, "LoginLTI">>();
  const { login } = useAuth();
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
  const { isCompanionMode } = useAppConfig();

  useFocusEffect(
    useCallback(() => {
      let isActive = true;
      const triggerLogin = async () => {
        if (!route.params?.accessToken || !route.params?.refreshToken) {
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
          return;
        }

        const authResult = await login(route.params.accessToken, route.params.refreshToken);

        if (!isActive) {
          return;
        }

        const isVerified = authResult.isEmailVerified && authResult.otpVerifiedForSession;
        if (!isVerified) {
          navigation.reset({
            index: 0,
            routes: [{ name: "Verify Email" }],
          });
          return;
        }

        const storedReturnToUrl = await returnToUtils.getAndClearReturnToUrl();

        let targetUrl: string | null = storedReturnToUrl;

        if (!targetUrl && route.params?.redirect && returnToUtils.isValidInternalUrl(route.params.redirect)) {
          targetUrl = route.params.redirect;
        }

        if (targetUrl) {
          window.location.href = targetUrl;
        } else {
          const redirect = getDefaultAuthenticatedRoute({
            userRole: authResult.userRole,
            isCompanionMode,
          });
          navigation.reset({
            index: 0,
            routes: [{ name: redirect }],
          });
        }
      };

      triggerLogin();

      return () => {
        isActive = false;
      };
    }, [
      isCompanionMode,
      login,
      navigation,
      route.params?.accessToken,
      route.params?.redirect,
      route.params?.refreshToken,
    ])
  );

  return (
    <BlankLayout>
      <Loader />
    </BlankLayout>
  );
}

export default LoginLTIView;
